import { render, staticRenderFns } from "./openBurse.vue?vue&type=template&id=2b2fc3dd&scoped=true"
import script from "./openBurse.vue?vue&type=script&lang=js"
export * from "./openBurse.vue?vue&type=script&lang=js"
import style0 from "./openBurse.vue?vue&type=style&index=0&id=2b2fc3dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2fc3dd",
  null
  
)

export default component.exports